import styled from 'styled-components'

export const Container = styled.section`
	float: left;
	width: 100%;
	background-color: #0A121F;
	display: flex;
	align-items: initial;
	justify-content: center;
	padding: 0 60px 60px 60px;

	@media only screen and (max-width: 1100px) {
		display: inline-block;
		padding: 20px 20px 40px 20px;
	}
`
